import { useEffect } from "react"

import { useGoogleLogin, useGoogleOAuth } from "@react-oauth/google"
import { Card, Layout, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useParams } from "react-router"
import { useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../../Components/Button"
import LoginForm from "../../Components/Forms/LoginForm"
import LoginHeader from "../../Components/LoginHeader"
//import ShopifyLoginBtn from '../../Components/ShopifyLoginBtn'
import PrivacyPolicy from "../../Components/PrivacyPolicy"
import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import Images from "../../Images"
import { getAdminPostLoginRoute, isPublicAdminRoute } from "../../Utils/adminTwoFactor"
import { defaultInnerPage } from "../../Utils/appRoutes"
import { isOnboardingFinished } from "../../Utils/onboarding/isOnboardingFinished"
import { onboardingResumePath } from "../../Utils/onboarding/productChoice"
import { useQuery } from "../../Utils/utils"
import { authErrorReset } from "./redux/auth.actions"
import { signIn, socialAuth } from "./redux/auth.thunks"

//import Modal from "../../Components/Modal"

const { Text } = Typography

function LoginPage(props) {
  const { auth, error, fetching, isMobile } = props

  const navigate = useNavigate()
  const { hash } = useParams()
  const { pathname, search } = useLocation()
  const { scriptLoadedSuccessfully } = useGoogleOAuth()
  const { t } = useTranslation()
  const query = useQuery(search)
  const externalDemoMode = useExternalDemoMode()
  const next_page = query.get("next_page")

  const otpRequired = error?.otp_required

  function handleSubmit({ email, password, otp_pass = null }) {
    const params = new URLSearchParams(search)
    const parsedParams = search ? Object.fromEntries(params.entries()) : null
    const nextUrl = search?.includes("?next=") ? search.split("?next=")?.[1] : null

    const data = {
      email,
      password,
      ...(otpRequired && { otp_pass }),
      ...(parsedParams && !parsedParams?.next && { extra: parsedParams }),
      ...(nextUrl && { redirect: nextUrl }),
      ...(next_page && { next_page })
    }
    props.signIn(data)
  }

  const responseGoogle = useGoogleLogin({
    onSuccess: (response) => {
      if (response && response?.access_token) {
        props.socialAuth(response?.access_token, "google")
      }
    },
    onFailure: (response) => {
      if (response && response?.access_token) {
        props.socialAuth(response?.access_token, "google")
      }
    }
  })

  useEffect(() => {
    document.title = "Login - Chargeback"
    if (hash) localStorage.setItem("ref_link_info", hash)
    if (auth.userInfo && !auth.isAdmin) {
      if (isOnboardingFinished(auth.userInfo)) {
        const defaultRoute = defaultInnerPage
        navigate(defaultRoute + (search || ""))
      } else {
        if (auth.userInfo?.["is_email_verified"]) {
          if (auth?.userInfo?.next_step)
            navigate(onboardingResumePath(auth?.userInfo) + (search || ""))
        } else {
          navigate("/getting_started" + (search || ""))
        }
      }
    } else if (auth.userInfo && auth.isAdmin && !isPublicAdminRoute(pathname)) {
      navigate(getAdminPostLoginRoute(auth.userInfo))
    }
    if (error) props.resetError()
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  /*const handleAuthShopify = (shopifyShop) => {
    props.shopifyAuth(shopifyShop)
  }*/

  return (
    <Layout>
      <Spin size="large" spinning={externalDemoMode ? false : fetching}>
        <div className="login-row">
          <LoginHeader />
          {error && (typeof error === "string" || otpRequired) && (
            <div className={"force-logout-error"}>
              {typeof error === "string" ? error : "OTP is required"}
            </div>
          )}
          <div className="login-content">
            <div className="content-main sign-up">
              {!externalDemoMode ? (
                <>
                  <Card className="login-card">
                    <h2 className="card-title" style={{ marginBottom: 24 }}>
                      {t("Sign In")}
                    </h2>
                    <LoginForm
                      onSubmit={handleSubmit}
                      error={error?.message}
                      otpRequired={otpRequired}
                      resetError={() => props.resetError()}
                    >
                      <div className="social-btn-block">
                        {/*<ShopifyLoginBtn
                      btnText={`${isMobile ? '' : `${t('Sign in with')} `}Shopify`}
                      handleOk={handleAuthShopify}
                      fetching={fetching}
                    />*/}

                        <ButtonComponent
                          size="large"
                          onClick={responseGoogle}
                          block
                          disabled={!scriptLoadedSuccessfully}
                        >
                          <img className="btn-icon icon-space" src={Images.google} alt="" />
                          {`${t("Sign in with")} `}Google
                        </ButtonComponent>
                      </div>

                      <div className="social-title">
                        <div className="middle-line" />
                        <span>{t("or")}</span>
                        <div className="middle-line" />
                      </div>
                    </LoginForm>

                    {/*<div style={{marginTop: '16px'}}>
                  <Text type="secondary">
                    {t("Don't have an account?")}{' '}
                  </Text>
                  <Text type="link" className="text-link" onClick={() => navigate('/sign-up')}>
                    {t('Sign up here')}
                  </Text>
                </div>*/}
                  </Card>
                  <PrivacyPolicy />
                </>
              ) : (
                <Spin size="large" spinning={fetching}></Spin>
              )}
            </div>
          </div>
        </div>
      </Spin>

      {/*<Modal
        className={cls("change-modal custom-modal")}
        getContainer={() => document.getElementById('global-wrap')}
        {...(isMobile ? {transitionName: ''} : null)}
        open={visible}
        centered={!isMobile}
        closeIcon={
          <Icon role="icon" type="close_modal" color={"#707BA0"} opacity={1}/>
        }
        footer={null}
        closable="true"
        onCancel={() => setVisible(false)}
        destroyOnClose
        width={512}
      >
        <div className={'facebook-unavailable'}>
          <p>
            We sincerely apologize for the inconvenience, but due to recent changes in Facebook/Meta's Terms of Service and continuous
            issues with their side of API integration we are removing the ability to sign up or login through their services.
          </p>
          <p>
            Please use the <a href="/restore-password">reset password</a> feature with the email linked to Facebook, or the one you set for
            your account.
          </p>
        </div>
      </Modal>*/}
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  error: state.auth.error,
  fetching: state.auth.fetching,
  isMobile: state.nav.isMobile
})

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  signIn: (data) => dispatch(signIn(data)),
  resetError: () => dispatch(authErrorReset()),
  socialAuth: (accessToken, type, user) =>
    dispatch(socialAuth({ accessToken, socialType: type, user }))
  //shopifyAuth: (shopUrl) => dispatch(shopifyAuth(shopUrl)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
